<template>
  <div>
    <b-modal
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      :title="isEdit ? 'Update Employee' : 'Add New Employee'"
      v-model="showModal"
      size="lg"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-tabs>
            <b-tab title="Contact Detail">
              <b-row>
                <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">
                      First Name:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      v-model="$v.form.firstName.$model"
                      :state="$v.form.firstName.$dirty ? !$v.form.firstName.$error : null"
                      size="sm"
                      type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback>This Field is required.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group style="margin-top: 12px;">
                    <label class="text-left">Country of Residence:</label>
                    <v-select
                      :class="'form-control-small'"
                      label="text"
                      v-model="form.country"
                      :options="countryOptions"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">
                      Last Name:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      v-model="$v.form.lastName.$model"
                      :state="$v.form.lastName.$dirty ? !$v.form.lastName.$error : null"
                      size="sm"
                      type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback>This Field is required.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Date of Birth:"
                    style="margin-top: 12px;"
                  >
                    <b-form-datepicker
                      v-model="form.dateofBirth"
                      locale="en"
                      placeholder="Choose a date of birth"
                    ></b-form-datepicker>
                    <!-- <b-input-group>
                      <Datepicker
                        wrapper-class="form-control-small-date-picker"
                        input-class="custom-date-picker form-control-small"
                        calendar-class="date-calender"
                        class="form-control"
                        :format="formatDate"
                        v-model.lazy="form.dateofBirth"
                      ></Datepicker>
                      <b-input-group-append>
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                        >
                          <i class="fa fa-calendar"></i>
                        </span>
                      </b-input-group-append>
                    </b-input-group> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group style="margin-top: 12px;">
                    <label class="text-left">
                      Phone:
                      <!-- <span class="required-span">*</span> -->
                      <!-- :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null" -->
                    </label>
                    <b-form-input
                      v-model="form.phone"
                      onpaste="return false;"
                      onkeydown="return event.keyCode !== 69"
                      size="sm"
                      type="number"
                    ></b-form-input>
                    <!-- <b-form-invalid-feedback>This Field is required.</b-form-invalid-feedback> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group style="margin-top: 12px;">
                    <label class="text-left">
                      Email:
                      <!-- <span class="required-span">*</span> -->
                    </label>
                    <b-form-input
                      :disabled="isEdit"
                      v-model="$v.form.email.$model"
                      :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                      :class="invalidEmail ? 'existedEmailStyle' : null"
                      @change="checkEmailExist($event)"
                      size="sm"
                      type="email"
                    ></b-form-input>
                    <p
                      v-if="invalidEmail"
                      class="mb-0 text-feedback"
                    >{{invalidEmail}}</p>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Preferred Language:"
                    style="margin-top: 12px;"
                  >
                    <b-form-select
                      v-model="form.preferredLanguage"
                      size="sm"
                      :options="languageOptions"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Employee Detail">
              <b-row>
                <!-- <b-col cols="6">
                    <b-form-group>
                      <label class="text-left">
                        User Name:
                        <span class="required-span">*</span>
                      </label>
                      <b-form-input
                        v-model="$v.form.userName.$model"
                        :state="$v.form.userName.$dirty ? !$v.form.userName.$error : null"
                        size="sm"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                </b-col>-->
                <!-- <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">
                      Employee Number:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      v-model="$v.form.employeeNumber.$model"
                      :state="$v.form.employeeNumber.$dirty ? !$v.form.employeeNumber.$error : null"
                      size="sm"
                    ></b-form-input>
                    <b-form-invalid-feedback>This Field is required.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>-->
                <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">
                      Employee Email:
                      <span class="required-span">*</span>
                    </label>
                    <b-form-input
                      :disabled="isEdit"
                      v-model="$v.form.employeeEmail.$model"
                      :state="$v.form.employeeEmail.$dirty ? !$v.form.employeeEmail.$error : null"
                      size="sm"
                      type="email"
                    ></b-form-input>
                    <b-form-invalid-feedback>This Field is required.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">Division/Business Unit:</label>
                    <v-select
                      :class="'form-control-small'"
                      label="text"
                      v-model="form.department"
                      :options="departmentsOptions"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Date of Joining:">
                    <b-form-datepicker
                      v-model="form.dateOfJoining"
                      locale="en"
                      placeholder=""
                    ></b-form-datepicker>
                    <!-- <b-input-group>
                      <Datepicker
                        wrapper-class="form-control-small-date-picker"
                        input-class="custom-date-picker form-control-small"
                        calendar-class="date-calender"
                        class="form-control"
                        :format="formatDate"
                        v-model.lazy="form.dateOfJoining"
                      ></Datepicker>
                      <b-input-group-append>
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                        >
                          <i class="fa fa-calendar"></i>
                        </span>
                      </b-input-group-append>
                    </b-input-group> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Contract Start Date:">
                    <b-form-datepicker
                      v-model="form.contractStartDate"
                      locale="en"
                      placeholder=""
                    ></b-form-datepicker>
                    <!-- <b-input-group>
                      <Datepicker
                        wrapper-class="form-control-small-date-picker"
                        input-class="custom-date-picker form-control-small"
                        calendar-class="date-calender"
                        class="form-control"
                        :format="formatDate"
                        v-model.lazy="form.contractStartDate"
                      ></Datepicker>
                      <b-input-group-append>
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                        >
                          <i class="fa fa-calendar"></i>
                        </span>
                      </b-input-group-append>
                    </b-input-group> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Contract End Date:">
                    <b-form-datepicker
                      v-model="form.contractEndDate"
                      locale="en"
                      placeholder=""
                    ></b-form-datepicker>
                    <!-- <b-input-group>
                      <Datepicker
                        wrapper-class="form-control-small-date-picker"
                        input-class="custom-date-picker form-control-small"
                        calendar-class="date-calender"
                        class="form-control"
                        :format="formatDate"
                        v-model.lazy="form.contractEndDate"
                      ></Datepicker>
                      <b-input-group-append>
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                        >
                          <i class="fa fa-calendar"></i>
                        </span>
                      </b-input-group-append>
                    </b-input-group> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Contract Renew Date:">
                    <b-form-datepicker
                      v-model="form.contractRenewDate"
                      locale="en"
                      placeholder=""
                    ></b-form-datepicker>
                    <!-- <b-input-group>
                      <Datepicker
                        wrapper-class="form-control-small-date-picker"
                        input-class="custom-date-picker form-control-small"
                        calendar-class="date-calender"
                        class="form-control"
                        :format="formatDate"
                        v-model.lazy="form.contractRenewDate"
                      ></Datepicker>
                      <b-input-group-append>
                        <span
                          class="input-group-text"
                          id="basic-addon2"
                        >
                          <i class="fa fa-calendar"></i>
                        </span>
                      </b-input-group-append>
                    </b-input-group> -->
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group>
                    <label class="text-left">Employee Roles:</label>
                    <v-select
                      :class="'form-control-small'"
                      label="text"
                      v-model="form.employeeRoles"
                      :options="employeeRolesOptions"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="6">
                  <b-form-group :invalid-feedback="invalidUniqueIdentifier">
                    <label class="text-left">
                      Unique Identifier:
                    </label>
                    <b-form-input
                      v-model="form.uniqueIdentifier"
                      :state="invalidUniqueIdentifier ? false : null"
                      @change="checkUniqueIdentifierExist($event)"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                </b-col>-->
                <b-col cols="6">
                  <b-form-radio-group
                    v-model="form.selectedEmployeeStatus"
                    style="margin-top: 30px;"
                  >
                    <b-form-radio :value="null">Non</b-form-radio>
                    <b-form-radio value="is_senior_management">Is Senior Management</b-form-radio>
                    <b-form-radio value="is_c_suite_officer">Is C Suite Officer</b-form-radio>
                  </b-form-radio-group>
                </b-col>
                <b-col
                  cols="6"
                  v-if="!isEdit"
                >
                  <b-form-group style="margin-top: 20px;">
                    <b-form-checkbox
                      v-model="form.isGovernance"
                      switch
                    >Is Governance</b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{isEdit ? 'Your Employee is being Updating......' : 'Your Employee is being Creating......'}}</p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{isEdit ? 'Employee information successfully updated' : form.isGovernance ? "Employee information successfully added. Compliance forms successfully sent to employee’s email address." : "Employee information successfully added"}}
            <br />
          </p>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="closeModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{isEdit ? 'Update' : 'Save'}}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/es";
import { HTTP } from "../../../utils/HTTP";
import { Helper } from "../../../helpers";
import { EventBus } from "@/event-bus.js";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
export default {
  name: "AddEmployeeModal",
  mixins: [validationMixin],
  components: {
    Datepicker,
  },
  data () {
    return {
      showModal: false,
      divisionOptions: [
        { value: null, text: "Select Division..." },
        { value: "credit", text: "Credit" },
        { value: "debit", text: "Debit" },
      ],
      languageOptions: [],
      countryOptions: [],
      departmentsOptions: [],
      employeeRolesOptions: [],
      onboardingTypeOptions: [],
      form: {
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        dateofBirth: null,
        userName: null,
        employeeNumber: null,
        employeeEmail: null,
        country: null,
        preferredLanguage: 1,
        department: null,
        dateOfJoining: null,
        contractStartDate: null,
        contractEndDate: null,
        contractRenewDate: null,
        employeeRoles: null,
        isGovernance: false,
        selectedEmployeeStatus: null,
        onboardingType: null,
        uniqueIdentifier: null,
      },
      employeeId: null,
      isEdit: false,
      submiting: false,
      responseSuccess: false,
      invalidEmail: null,
      invalidUniqueIdentifier: null,
    };
  },
  created () {
    EventBus.$on( "onShowAddEmployeeModal", () => {
      this.showAddEmployee();
    } );
    EventBus.$on( "onShowEditEmployeeModal", ( data ) => {
      this.showEditEmployee( data );
    } );
  },
  mounted () {
    this.getEmployeeLanguages();
    this.getEmployeeCountry();
    this.getDepartmentsList();
    this.getEmployeeRoles();
    this.getOnboardingTypes();
  },
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
      // phone: { required },
      // employeeNumber: { required },
      email: { email },
      // userName: { required },
      employeeEmail: { required, email },
    },
  },
  methods: {
    showAddEmployee () {
      this.showModal = true;
    },
    showEditEmployee ( data ) {
      this.isEdit = true;
      this.employeeId = data.item.id;
      let countryValueIndex = this.countryOptions.findIndex(
        ( x ) => x.value == data.item.employee_country_id
      )
      let departmentValueIndex = this.departmentsOptions.findIndex(
        ( x ) => x.value == data.item.department_id
      )
      this.form = {
        firstName: data.item.first_name,
        lastName: data.item.last_name,
        phone: data.item.phone,
        email: data.item.email,
        dateofBirth: data.item.date_of_birth,
        userName: null,
        employeeNumber: data.item.employee_number,
        employeeEmail: data.item.email,
        country: this.countryOptions[countryValueIndex],
        preferredLanguage: data.item.employee_language_id,
        department: this.departmentsOptions[departmentValueIndex],
        dateOfJoining: data.item.date_of_joining,
        contractStartDate: data.item.contract_start_date,
        contractEndDate: data.item.contract_end_date,
        contractRenewDate: data.item.contract_renew_date,
        employeeRoles: data.item.employee_job_role_id,
        isGovernance: false,
        selectedEmployeeStatus: data.item.is_c_suite_officer == 1 ? 'is_c_suite_officer' : data.item.is_senior_management ? 'is_senior_management' : null,
        onboardingType: null,
        uniqueIdentifier: null,
      };
      this.showModal = true;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
    async getEmployeeLanguages () {
      this.languageOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languageOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeCountry () {
      this.countryOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/country-list", null );
        this.countryOptions = result.data.employeeCountry;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getDepartmentsList () {
      this.departmentsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/constants/departments-list",
          null
        );
        this.departmentsOptions = result.data.departments;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeRoles () {
      this.employeeRolesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/roles", null );
        this.employeeRolesOptions = result.data.employeeRoles;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getOnboardingTypes () {
      this.onboardingTypeOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/onboarding/onboarding-type-list",
          null
        );
        this.onboardingTypeOptions = result.data.onboardingType;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM/YYYY" );
      }
    },
    async checkEmailExist ( value ) {
      let formData = {
        email: value,
        user_id: localStorage.getItem( "userId" ),
      };
      let result = HTTP( "post", "api/v1/employees/check-exist-email", formData );

      return result
        .then( ( response ) => {
          if ( response.data.email == value ) {
            this.invalidEmail =
              "This Email Already Exist Please Change Email Address";
          } else if ( response.data === [] ) {
            return "";
          } else {
            this.invalidEmail = null;
          }
        } )
        .catch( ( error ) => {
          return [error];
        } );
    },
    async checkUniqueIdentifierExist ( value ) {
      let formData = {
        client_uid: value,
        user_id: localStorage.getItem( "userId" ),
      };
      let result = HTTP( "post", "api/v1/employees/check-client-uid", formData );

      return result
        .then( ( response ) => {
          if ( response.data.client_uid == value ) {
            this.invalidUniqueIdentifier =
              "This Unique Identifier Already Exist Please Change Unique Identifier";
          } else if ( response.data === [] ) {
            return "";
          } else {
            this.invalidUniqueIdentifier = null;
          }
        } )
        .catch( ( error ) => {
          return [error];
        } );
    },
    resetForm () {
      this.form = {
        firstName: null,
        lastName: null,
        phone: null,
        email: null,
        dateofBirth: null,
        userName: null,
        employeeNumber: null,
        employeeEmail: null,
        country: null,
        preferredLanguage: 1,
        department: null,
        dateOfJoining: null,
        contractStartDate: null,
        contractEndDate: null,
        contractRenewDate: null,
        employeeRoles: null,
        isGovernance: false,
        onboardingType: null,
        selectedEmployeeStatus: null,
        uniqueIdentifier: null,
      };
    },
    closeModal () {
      this.resetForm();
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
      this.$v.$reset();
      this.showModal = false;
      this.isEdit = false;
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEdit ) {
        this.updateEmployee().then( this.reloadTable );
      } else {
        if ( this.invalidEmail ) {
          return;
        } else {
          this.saveEmployee().then( this.reloadTable );
        }
      }
    },
    makeToster ( tosterVarient, tosterMsg ) {
      this.closeModal();
      Helper.makeToast( this.$bvToast, tosterVarient, tosterMsg );
    },
    async updateEmployee () {
      let formData = {
        employee_id: this.employeeId,
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        phone: this.form.phone,
        date_of_birth: this.form.dateofBirth,
        username: this.form.userName,
        employee_number: this.form.employeeNumber,
        client_uid: this.form.uniqueIdentifier,
        employee_country_id: this.form.country ? this.form.country.value : null,
        employee_language_id: this.form.preferredLanguage,
        department_id: this.form.department ? this.form.department.value : null,
        employee_role_id: this.form.employeeRoles ? this.form.employeeRoles.value : null,
        is_governance: this.form.isGovernance ? 1 : 0,
        date_of_joining: this.form.dateOfJoining,
        contract_start_date: this.form.contractStartDate,
        is_senior_management: this.form.selectedEmployeeStatus == "is_senior_management" ? 1 : 0,
        is_c_suite_officer: this.form.selectedEmployeeStatus == "is_c_suite_officer" ? 1 : 0,
        contract_end_date: this.form.contractEndDate,
        contract_renew_date: this.form.contractRenewDate,
        userId: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/employees/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data && result.data.success == 1 ) {
          this.makeToster( "success", "Employee information successfully updated" );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async saveEmployee () {
      let formData = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        phone: this.form.phone,
        email: this.form.email,
        date_of_birth: this.form.dateofBirth,
        username: this.form.userName,
        employee_number: this.form.employeeNumber,
        client_uid: this.form.uniqueIdentifier,
        employee_email: this.form.employeeEmail,
        employee_country_id: this.form.country ? this.form.country.value : null,
        employee_language_id: this.form.preferredLanguage,
        department_id: this.form.department ? this.form.department.value : null,
        employee_role_id: this.form.employeeRoles ? this.form.employeeRoles.value : null,
        is_governance: this.form.isGovernance ? 1 : 0,
        date_of_joining: this.form.dateOfJoining,
        contract_start_date: this.form.contractStartDate,
        is_senior_management: this.form.selectedEmployeeStatus == "is_senior_management" ? 1 : 0,
        is_c_suite_officer: this.form.selectedEmployeeStatus == "is_c_suite_officer" ? 1 : 0,
        contract_end_date: this.form.contractEndDate,
        contract_renew_date: this.form.contractRenewDate,
        userId: localStorage.getItem( "userId" ),
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP( "post", "api/v1/employees/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
        if ( result.data && result.data.success == 1 ) {
          this.makeToster(
            "success",
            "Employee information successfully added. Compliance forms successfully sent to employee’s email address."
          );
        }
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>
<style scoped>
.existedEmailStyle {
  border-color: #e71d36 !important;
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}
.existedEmailStyle:focus {
  border-color: #e71d36 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>